import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    "&.isHide": {
      display: "none",
    },
  },
});
